import API from './base';

const version = 'v1';

export default {
  shippingServiceRequest(payload) {
    return API.post(`${version}/shipping/request`, payload);
  },
};
